<template>
  <div id="app">
    <router-view v-if="isRouterAlive" @reload="reload"/>
    <loading />
  </div>
</template>
<script>
import Loading from '@/components/Loading'

export default {
  components: { Loading },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },

  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100vh;
}
body {
  margin:0;
  font-family: Helvetica, sans-serif;
}
.tableBox {
  //border-radius: 4px;
  font-size: 13px;
  color: #333333;
  p{
    margin: 8px 0 !important;
  }
  th{
    padding: 0 !important;
    height: 40px;
    line-height: 40px;
    color: #333;
    text-align: center;
    background: #f8f8f8;
    /*background-color: rgba(7,20,90,0.6);
    /*background: linear-gradient(to top, #f2f8ff , #afddfb);*/
    /*background: linear-gradient(to top, #f7f7f7 , #e7e7e7);*/
  }
  td{
    padding: 0 !important;
    text-align: center;
    height: 50px;
    line-height: 50px;
  }
}
.el-select {
  width: 100%;
}

// 解决移动端select需要点击二次才能选中
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue